import { AppId, Route, createPageRoute } from '@lumapps/router';

export const broadcastAnalyticsRoute: Route = createPageRoute({
    slug: 'analytics/broadcast',
    id: 'broadcast-analytics',
    appId: AppId.backOffice,
});
